module.exports = __webpack_public_path__ + "static/media/body-bg-4.500595d2.jpg";